import { useLang } from '@/i18n';
import getLocal from 'eco-design-reliance/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import css from './index.module.scss';

export default function Sustainability() {
    const { t } = useLang('corporatesocialresponsibility.Sustainability');
    const { locale = '' } = getLocal();
    return (
        <div className={`${css.Sustainability} csr-Sustainability GtmModuleData-section`} id="csr-Sustainability">
            <div className="bg-img">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/figma-uploads/1786005417255-dz0nyd-compressed-PC.jpg"
                    h5="https://websiteoss.ecoflow.com/figma-uploads/1786005439038-f5dvfp-compressed-mob.jpg"
                    alt={t('title')}
                />
            </div>
            <div className="box">
                <h2 className="title">{t('title')}</h2>
                <p className="desc">{t('desc')}</p>
                <div className="inner">
                    <div className="info">
                        <h3 className="name">{t('name')}</h3>
                        <p className="text">{t('text')}</p>
                    </div>
                    <EcoLink
                        className="btn"
                        href={
                            locale === 'cn'
                                ? 'https://websiteoss.ecoflow.com/upload/pdf/1786008299383/%E3%80%90CN%E3%80%91ECOFLOW%202025%E5%B9%B4%E5%BA%A6%E5%8F%AF%E6%8C%81%E7%BB%AD%E5%8F%91%E5%B1%95%E6%8A%A5%E5%91%8A-0708.pdf'
                                : 'https://websiteoss.ecoflow.com/upload/pdf/1786008307210/%E3%80%90EN%E3%80%91ECOFLOW%202025%20Sustainability%20Report-0708.pdf'
                        }
                        aria-label={t('btn')}
                    >
                        <span>{t('btn')}</span>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16.667 11.0439C17.0121 11.0439 17.2918 11.3239 17.292 11.6689V15.8359C17.2918 16.6412 16.6393 17.2939 15.834 17.2939H4.16699C3.36184 17.2938 2.70916 16.6411 2.70898 15.8359V11.6689C2.70916 11.3239 2.98892 11.0439 3.33398 11.0439C3.67905 11.0439 3.95881 11.3239 3.95898 11.6689V15.8359C3.95916 15.9507 4.05219 16.0438 4.16699 16.0439H15.834C15.9489 16.0439 16.0418 15.9508 16.042 15.8359V11.6689C16.0422 11.324 16.3221 11.0441 16.667 11.0439ZM10.001 2.71094C10.346 2.71111 10.626 2.99087 10.626 3.33594V11.8262L13.7256 8.72754C13.9697 8.48346 14.3653 8.48346 14.6094 8.72754C14.8533 8.97163 14.8534 9.3673 14.6094 9.61133L10.4424 13.7783C10.1983 14.022 9.80258 14.0221 9.55859 13.7783L5.3916 9.61133C5.14779 9.36735 5.1479 8.97159 5.3916 8.72754C5.63568 8.48346 6.03229 8.48346 6.27637 8.72754L9.37598 11.8271V3.33594C9.37598 2.99076 9.6558 2.71094 10.001 2.71094Z"
                                fill="currentColor"
                            />
                        </svg>
                    </EcoLink>
                </div>
            </div>
        </div>
    );
}
